module.exports = __webpack_public_path__ + "static/CircularStd-Black-b5fa1b553516d1cf8d03d6b4588058a0.woff";